import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import s from './DateInput.module.scss';
import clsx from 'clsx';
import { flip, shift } from '@floating-ui/dom';
import { PortalToBody } from '../../components/util/PortalToBody';
import { range } from './index';
import { getMonth, getYear } from 'date-fns';

type Props = {
  value: Date | null;
  onChange: (date: Date | null) => void;
  tabIndex?: number;
  id?: string;
  className?: string;
  placeholder?: string;
  isClearable?: boolean;
  disabled?: boolean;
  filterDate?: (date: Date) => boolean;
};

export function DateInput({ value, onChange, tabIndex, id, className, placeholder, isClearable, disabled, filterDate }: Props) {
  const years = range(2014, getYear(new Date()) + 1, 1);
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  return (
    <DatePicker
      renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
        <div
          style={{
            margin: '5px 0',
            display: 'flex',
            justifyContent: 'space-evenly'
          }}
        >
          <button className='btn' onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
            {'<'}
          </button>
          <select value={months[getMonth(date)]} onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}>
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <select value={getYear(date)} onChange={({ target: { value } }) => changeYear(parseInt(value))}>
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <button className='btn' onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
            {'>'}
          </button>
        </div>
      )}
      todayButton='Today'
      fixedHeight={true}
      className={clsx('form-control', className)}
      popperClassName={s['popper-container']}
      tabIndex={tabIndex}
      disabled={disabled}
      placeholderText={placeholder}
      popperContainer={PortalToBody}
      selected={value}
      isClearable={isClearable}
      id={id}
      onKeyDown={(e) => e.preventDefault()}
      onChange={onChange}
      filterDate={filterDate} // Only allow Mondays
      popperModifiers={[shift(), flip()]}
    />
  );
}
